import React from 'react';
import { Typography } from '@raisin/components-lib';
import { handleLocaleChange } from './utils';
import * as S from './styles';
import { markets } from '../../data';

export const FlagsGrid = () => (
  <S.Grid>
    {Object.values(markets).map((market) => (
      <S.CountryCard key={market.preferredLocale}>
        <S.Link
          href={market.link}
          onClick={(event) => handleLocaleChange(event, market.preferredLocale)}
        />
        <S.SVGWrapper>{market.flag}</S.SVGWrapper>
        <Typography variant="subtitle1">{market.country}</Typography>
      </S.CountryCard>
    ))}
  </S.Grid>
);
